namespace RioERP.Inventory {
    export interface BookInwardForm {
        BookId: Serenity.LookupEditor;
        Qty: Serenity.IntegerEditor;
        InwardDate: Serenity.DateEditor;
        Rate: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
        VendorId: Serenity.IntegerEditor;
        BillDocument: Serenity.StringEditor;
        Notes: Serenity.StringEditor;
    }

    export class BookInwardForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.BookInward';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!BookInwardForm.init)  {
                BookInwardForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DateEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.StringEditor;

                Q.initFormType(BookInwardForm, [
                    'BookId', w0,
                    'Qty', w1,
                    'InwardDate', w2,
                    'Rate', w3,
                    'Amount', w3,
                    'VendorId', w1,
                    'BillDocument', w4,
                    'Notes', w4
                ]);
            }
        }
    }
}
